import React, { createRef, useState } from "react";
import Wheel from "./Wheel";
import ProgressBar from "./ProgressBar";
import Button from "./Button";
import { useNavigate } from "react-router-dom";

const title = window.password_page.password_title;
const subtitle = window.password_page.password_subtitle;
const desc = window.password_page.password_description;
const field_title = window.password_page.password_field_title;
const placeholder = window.password_page.password_placeholder;

const PasswordScreen = ({
  wheel,
  categoryList,
  members,
  password,
  loginButton,
  invalidText,
  login
}) => {
  const passwordRef = createRef();
  const [isInvalid, setIsInvalid] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = e => {
    const passwordVal = passwordRef.current.value;

    if (password === passwordVal) {
      passwordRef.current.blur();
      setIsInvalid(false);

      login();
      navigate("/");
    } else {
      setIsInvalid(true);
    }
    e.preventDefault();
  };

  const showPassword = () => {
    const input = document.getElementById("password-input");

    if (input.getAttribute("type") === "password") {
      input.setAttribute("type", "text");
    } else {
      input.setAttribute("type", "password");
    }
  };
  const passwordClass = isInvalid ? "is-error" : "";
  const feedbackClass = `invalid-feedback ${isInvalid ? "" : "is-hidden"}`;
  return (
    <>
      <div className="password-screen">
        <div className="password-screen__left">
          <div className="password-screen__wrapper">
            <h3 className="password-screen__subtitle">{subtitle}</h3>
            <h1 className="password-screen__title">{title}</h1>
            <p
              className="password-screen__text"
              dangerouslySetInnerHTML={{ __html: desc }}
            />
          </div>
          <div className="password-screen__input-wrapper">
            <div className="password-screen__input">
              <h3 className="password-screen__input-title">{field_title}</h3>
              <div className="password-screen__input-container">
                <input
                  type="password"
                  ref={passwordRef}
                  id="password-input"
                  className={passwordClass}
                  placeholder={placeholder}
                />
                <button
                  type="button"
                  onClick={showPassword}
                  className="show-password"
                >
                  <img src="/wp-content/themes/teamconnector2/assets/images/eye-slash.png" />
                </button>
              </div>
              <div className={feedbackClass}>{invalidText}</div>
              <div>
                <p />
              </div>
            </div>
            <Button
              type="submit"
              {...loginButton}
              className="play"
              onClick={handleSubmit}
            />
          </div>
        </div>
        <div className="password-screen__right">
          <div className="introduction-screen__spinner">
            <Wheel
              members={members}
              data={categoryList}
              {...wheel}
              diameter={500}
            />
            <ProgressBar
              currentRound="-"
              totalRound=""
              isDisplayContent={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PasswordScreen;
